import { TournamentRoundStage } from "../../../../graphql/generated";
import { useTranslation } from "react-i18next";

export function useCurrentRound() {
  const { t } = useTranslation();

  return (round: TournamentRoundStage) => {
    switch (round) {
      case TournamentRoundStage.RoundOf_64:
        return `${t("instant_tournament.round_of")} 64`;
      case TournamentRoundStage.RoundOf_32:
        return `${t("instant_tournament.round_of")} 32`;
      case TournamentRoundStage.RoundOf_16:
        return `${t("instant_tournament.round_of")} 16`;
      case TournamentRoundStage.QuarterFinal:
        return t("instant_tournament.quarter_final");
      case TournamentRoundStage.SemiFinal:
        return t("instant_tournament.semi_final");
      case TournamentRoundStage.Final:
        return t("instant_tournament.final");
      default:
        return "";
    }
  };
}
